export const LOGIN = "login";
export const LOGOUT = "logout";

export const STORAGE_KEY = "kkowqcqwinqldGQWGIGLGU*(^*(%%57";

export const LoginAction = ({ token, type }) => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      token,
      type,
    })
  );
  return {
    type: LOGIN,
    token,
    userType: type,
  };
};

export const LogoutAction = () => {
  localStorage.clear(STORAGE_KEY);
  return {
    type: LOGOUT,
  };
};

export const AutoLogin = ({ token, type }) => {
  return {
    type: LOGIN,
    token,
    userType: type,
  };
};
